<div *ngIf="entrySummary">
  <es-attach-document
    *ngIf="isShowDocuments"
    [deliveryOrdersInfo]="deliveryOrdersInfo"
    [validationMessages]="allValidationMessages"
    [attachedDocuments]="attachedDocuments"
    [entrySummary]="entrySummary"
    [isCanUploadDocuments]="isCanUploadDocuments"
    [isCanRemoveDocuments]="canRemoveDocuments"
    [isOverrideDefaultPoaRequired]="isOverrideDefaultPoaRequired"
    [canUploadPunToCompany]="canUploadPunToCompany"
    [isShowEmptyLineItemDocuments]="false"
    [onlyLastVersionForFormDocuments]="onlyLastVersionForFormDocuments"
    [uploadFile]="uploadFile"
    [uploadCompanyFile]="uploadCompanyFile"
    [removeFile]="removeFile"
    [isHideDownloadAll]="isHideDownloadAll"
    (stateUpdate)="onDocumentStateUpdate($event)"
    (poaSidebarRequest)="onPoaSidebarRequest($event)"
    class="page-break-inside-avoid"
  ></es-attach-document>

  <ng-container *ngIf="!isInsuranceLoading">
    <app-marine-insurance-quote-pricing-card
      *ngIf="!isInsuranceAvailable && !isProviderWasDown && isEsSent && !paidOrSentPaymentStates.includes(currentInsurance?.paymentState)"
      [marineInsurance]="currentInsurance"
      [pendingBills]="currentInsurancePendingBills"
      [parent]="entrySummary"
      (edit)="openMarineInsuranceQuoteForm(true)"
    ></app-marine-insurance-quote-pricing-card>

    <app-marine-insurance-quote-view-card
      *ngIf="isProviderWasDown"
      [isEditable]="!isManagement"
      [marineInsurance]="currentInsurance"
      [documents]="currentInsuranceDocuments"
      [entity]="enumMarineInsuranceEntityType.ENTRY_SUMMARY"
      [state]="entrySummary.state"
      [isShowUpdated]="
        !!currentInsurance?.updatedInsuredValue?.insuredAmount &&
        (!currentInsurancePendingBills?.items?.length || currentInsurance?.partiallyRefundConfirmed)
      "
      [isPendingAdminApproval]="
        (!currentInsurancePendingBills?.items?.length &&
          currentInsurance?.pendingPaymentAction === enumMarineInsurancePendingPaymentAction.ADDITIONAL_PAYMENT) ||
        (currentInsurancePendingBills?.items?.length && currentInsurance?.partiallyRefundConfirmed)
      "
      (edit)="openMarineInsuranceQuoteForm(true)"
    ></app-marine-insurance-quote-view-card>

    <app-marine-insurance-quote-updated-pricing-card
      *ngIf="
        !isInsuranceAvailable &&
        isEsSent &&
        paidOrSentPaymentStates.includes(currentInsurance?.paymentState) &&
        currentInsurance?.pendingPaymentAction === enumMarineInsurancePendingPaymentAction.ADDITIONAL_PAYMENT &&
        currentInsurancePendingBills?.items?.length
      "
      [marineInsurance]="currentInsurance"
      [pendingBills]="currentInsurancePendingBills"
    ></app-marine-insurance-quote-updated-pricing-card>
  </ng-container>

  <es-details-shipment-card
    [allValidationMessages]="allValidationMessages"
    [entrySummary]="entrySummary"
    [canEdit]="isCanEdit"
    (edit)="onEditShipmentData()"
  ></es-details-shipment-card>
  <es-details-importer-card
    [entrySummary]="entrySummary"
    [canEdit]="false"
    (edit)="onEditImporter()"
    class="page-break-inside-avoid"
  ></es-details-importer-card>
  <es-details-bond-card
    *ngIf="isShowBond"
    [entrySummary]="entrySummary"
    [canEdit]="isCanEditBond"
    [isShowBR]="true"
    (edit)="onEditBond()"
    class="page-break-inside-avoid"
  ></es-details-bond-card>
  <ng-template [ngIf]="isPrinting$ | async">
    <es-details-total
      [title]="'LABELS.TOTALS' | translate"
      [entrySummary]="entrySummary"
      [dutiesValue]="dutiesValue"
      class="page-break-inside-avoid"
    ></es-details-total>
  </ng-template>
  <div
    class="page-break-before-always"
    [ngClass]="{ 'mt-3': isPrinting$ | async }"
    *ngFor="let shipment of entrySummary.shipments; let index = index"
  >
    <es-details-bill-of-lading-card
      [entrySummaryId]="entrySummary?.id"
      [shipment]="shipment"
      [hasSingleExportData]="entrySummary.hasSingleExportData"
      [index]="index"
      [isMultiBl]="isMultiBl"
      [canEdit]="isCanEdit"
      [transportationMode]="entrySummary.transportationMode"
      [isOpenInvoicesOnEdit]="isOpenInvoicesOnEdit"
      [connectedIsfs]="connectedIsfs"
      [isRequiredDocument]="entrySummary?.submissionType === enumEntrySummarySubmissionType.BROKER_ASSISTED"
      (edit)="onEditShipment($event)"
      (editConsignee)="onEditShipmentConsignee($event)"
      (editBuyer)="onEditShipmentBuyer($event)"
      (editSupplier)="onEditSupplier($event)"
      (editInvoice)="onEditInvoice($event)"
      (removeInvoice)="onRemoveInvoice($event)"
      (editInvoices)="onEditInvoices($event)"
      (removeShipment)="onRemoveShipment($event)"
    ></es-details-bill-of-lading-card>
  </div>

  <ng-container *ngIf="!isInsuranceLoading">
    <app-marine-insurance-quote-view-card
      *ngIf="
        (!isInsuranceAvailable && !isEsSent) ||
        paidOrSentPaymentStates.includes(currentInsurance?.paymentState) ||
        currentInsurance?.pendingPaymentAction === enumMarineInsurancePendingPaymentAction.ADDITIONAL_PAYMENT
      "
      [isEditable]="!isManagement"
      [marineInsurance]="currentInsurance"
      [documents]="currentInsuranceDocuments"
      [entity]="enumMarineInsuranceEntityType.ENTRY_SUMMARY"
      [state]="entrySummary.state"
      [isShowUpdated]="
        !!currentInsurance?.updatedInsuredValue?.insuredAmount &&
        (!currentInsurancePendingBills?.items?.length || currentInsurance?.partiallyRefundConfirmed)
      "
      [isPendingAdminApproval]="
        (!currentInsurancePendingBills?.items?.length &&
          currentInsurance?.pendingPaymentAction === enumMarineInsurancePendingPaymentAction.ADDITIONAL_PAYMENT) ||
        (currentInsurancePendingBills?.items?.length && currentInsurance?.partiallyRefundConfirmed)
      "
      (edit)="openMarineInsuranceQuoteForm(true)"
    ></app-marine-insurance-quote-view-card>
  </ng-container>

  <div class="d-print-none">
    <div *ngIf="isCanEdit && !isTruck" (click)="onEditShipment()" class="es-add-bl-card-container">
      <es-details-card
        [info]="{
          dashedBorder: true,
          title: 'ENTRY_SUMMARY.ADD_BILL_OF_LADING',
          bordered: true
        }"
        [index]="(entrySummary?.shipments?.length || 0) + 1"
      >
        <div class="row pt-3 px-3 align-items-center">
          <div class="shrink-0">
            <div class="circle">
              <div class="plus">+</div>
            </div>
          </div>
          <div class="col">
            <h6 class="add-bill-title mb-0">
              {{ ("ENTRY_SUMMARY.ADD_BILL_OF_LADING" | translate) + "" + ((entrySummary?.shipments?.length || 0) + 1) }}
            </h6>
            <div class="add-bill-description">{{ "ENTRY_SUMMARY.HAVE_MULTI_BL" | translate }}</div>
          </div>
        </div>
      </es-details-card>
    </div>
  </div>

  <ng-template [ngIf]="!(isPrinting$ | async)">
    <es-details-total
      [title]="'LABELS.TOTALS' | translate"
      [entrySummary]="entrySummary"
      [dutiesValue]="dutiesValue"
      class="page-break-inside-avoid"
    ></es-details-total>

    <div *ngIf="isShowPaymentCard" class="card-payment-container page-break-inside-avoid">
      <div class="pt-3">
        <ng-content select="[apply-coupon-card]"></ng-content>
      </div>
    </div>
  </ng-template>
</div>
